import Styles from './CreditsRemainingCta.module.scss'

import { Text } from 'blaze-ui/Text/Text'
import Server02 from 'blaze-ui/icons/16/Server02'
import { useRootStore } from 'stores/RootStore'
import { Button } from 'blaze-ui/Button'
import { useModals } from 'almanac-ui/Modal'
import { PurchaseContentCreditsModal } from '../PurchaseContentCreditsModal/PurchaseContentCreditsModal'
import { PaymentPlanKey } from 'api/clients/PaymentPlanClient'
import { useShowCreditsPaywall } from 'hooks/useShowCreditsPaywall'

export const CreditsRemainingCta = () => {
  const {
    tierUsageStore: { autopilotAddOns },
    creditUsageStore: { creditUsage },
  } = useRootStore()
  const { isTrackingCredits } = useShowCreditsPaywall()
  const { openModal } = useModals()
  const autopilotContentCreditsAddon = autopilotAddOns.find(
    (addon) => addon.key === PaymentPlanKey.BlazeAutopilotContentCredits,
  )
  const autopilotContentCreditsPrice = autopilotContentCreditsAddon?.prices[0]

  const onBuyMore = () => {
    if (!autopilotContentCreditsPrice) return

    openModal(PurchaseContentCreditsModal, { price: autopilotContentCreditsPrice })
  }

  if (!isTrackingCredits || !creditUsage || !autopilotContentCreditsAddon) return null

  return (
    <div className={Styles.container}>
      <div className={Styles.iconAndText}>
        <Server02 color="var(--dark-40)" />
        <Text variant="secondary">{creditUsage?.credits_remaining} credits remaining</Text>
      </div>
      <Button variant="ghost" onPress={onBuyMore}>
        Buy More
      </Button>
    </div>
  )
}
